export default "__VITE_ASSET__868c3d0e__"